import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.url,
    target: "_blank",
    class: _normalizeClass([{
        '-translate-y-40px': _ctx.scrolled,
        'opacity-100': _ctx.clicked,
        'pointer-events-none': !_ctx.clicked,
      }, "horiz-center opacity-0 transform-gpu transition-all duration-500 fixed h-23px w-23px sm:w-30px sm:h-30px flex-none mb-20px z-200 mix-blend-difference"])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spacer" }, null, -1)),
    _withDirectives(_createElementVNode("img", {
      class: "fill-white h-23px w-23px sm:w-30px sm:h-30px mr-15px",
      src: _ctx.img
    }, null, 8, _hoisted_2), [
      [_directive_svg_inline]
    ])
  ], 10, _hoisted_1))
}